<template>
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="4">
          <v-card class="pa-2">
            <v-card-title>
              <h4>Détail de la demande</h4>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <b>Cabinet: </b>
              {{ this.$store.getters["Auth/get_selected_demandeattestation"].nomCabinet }}
              <v-spacer class="my-1"></v-spacer>
              <b>Nom du chargé: </b>
              {{ this.$store.getters["Auth/get_selected_demandeattestation"].nomPersonne }}
              <v-spacer class="my-1"></v-spacer>
              <b>E-mail: </b>
              {{ this.$store.getters["Auth/get_selected_demandeattestation"].emailContact }}
              <v-spacer class="my-1"></v-spacer>
              <b>Date Demande: </b>
              {{ this.$store.getters["Auth/get_selected_demandeattestation"].dateDemande }}
              <v-spacer class="my-1"></v-spacer>
              <b>Status Demande: </b>
              {{ this.$store.getters["Auth/get_selected_demandeattestation"].status }}
              <v-spacer class="my-1"></v-spacer>
            </v-card-text>
          </v-card>
  
          <v-card class="mt-2" v-if="this.$store.getters['Auth/get_selected_demandeattestation'].status != 'Délivrée'">
            <v-card-title id="v-step-0">
              <h4>Répondre à la demande d'attestation</h4>
            </v-card-title>
            <v-card-text>
              <!-- Menu déroulant pour le choix "Valider" ou "Non Valider" -->
              <v-select v-model="isValidChoice" :items="['Je valide la demande', 'Demande non Validée']"
                label="Choix de validation"></v-select>
  
              <!-- Champs qui s'affichent lorsque "Valider" est choisi -->
              <div v-if="isValidChoice === 'Je valide la demande'">
                <v-file-input v-model="attestation.file_response" multiple label="Joindre l'attestation" truncate-length="15">
                  <template v-slot:selection="{ text }">
                    <v-chip small label color="primary">{{ text }}</v-chip>
                  </template>
                </v-file-input>
              </div>
  
              <!-- Champs qui s'affichent lorsque "Non Valider" est choisi -->
              <div v-if="isValidChoice === 'Demande non Validée'">
                <v-file-input v-model="attestation.file_response" multiple label="Joindre la lettre de rejet"
                  truncate-length="15">
                  <template v-slot:selection="{ text }">
                    <v-chip small label color="primary">{{ text }}</v-chip>
                  </template>
                </v-file-input>
              </div>
              <v-btn small color="primary" class="ma-2 white--text" block
                @click="submitResponse">
                <v-icon class="mr-2" dark>mdi-cloud-upload</v-icon>Envoyer
              </v-btn>
            </v-card-text>
          </v-card>
  
        </v-col>
        <v-col cols="12" md="8">
          <v-card>
            <v-card-title>
              <h4>Aperçu de la demande</h4>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="height:62em !important;overflow:hidden">
              <VueDocPreview style="height:100%" v-if="this.$store.getters['Auth/get_selected_demandeattestation'].extensionDemande == 'doc' ||
                this.$store.getters['Auth/get_selected_demandeattestation'].extensionDemande == 'docx' ||
                this.$store.getters['Auth/get_selected_demandeattestation'].extensionDemande == 'xls' ||
                this.$store.getters['Auth/get_selected_demandeattestation'].extensionDemande == 'xlsx' ||
                this.$store.getters['Auth/get_selected_demandeattestation'].extensionDemande == 'XLS' ||
                this.$store.getters['Auth/get_selected_demandeattestation'].extensionDemande == 'XLSX'
                " :value="this.$store.getters['Auth/get_selected_demandeattestation'].fileLinkDemande" type="office" />
  
              <vue-friendly-iframe v-if="this.$store.getters['Auth/get_selected_demandeattestation'].extensionDemande == 'pdf'"
                :src="this.$store.getters['Auth/get_selected_demandeattestation'].fileLinkDemande + '#toolbar=0'
                " frameborder="0" loading="lazy"></vue-friendly-iframe>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import VueDocPreview from "vue-doc-preview";
  
  export default {
    components: {
      VueDocPreview
    },
    props: {
      id: {
        type: Number,
        required: true
      }
    },
    data: () => ({
      profile: 0,
      dialog: false,
      attestation: {
        file_response: [],
      },
      InitLink: "",
      isLoading: false,
      isValidChoice: null,
    }),
    created() {
      this.$store.dispatch("Auth/loadDemandeAttestationById", this.id);
      let Virt = [];
      Virt = JSON.parse(localStorage.getItem("userData"));
      this.profile = Virt.profile.status;
    },
    methods: {
      getInit() {
        this.InitLink = this.$store.getters["Auth/get_selected_demandeattestation"].file_link_demande;
        console.log("INFOS", InitLink);
      },
      downloadFiche() {
        const data = new FormData();
        data.append("id", this.id);
        this.$store.dispatch("Auth/downloadFiche", data);
      },
      async submitResponse() {
        this.isLoading = true;
        try {
          if (this.isValidChoice === 'Je valide la demande') {
            // Call the validatePPM API here
            const formData = new FormData();
            formData.append('attestation_id', this.id);
            formData.append('status', "Délivrée");
            formData.append('file_response', this.attestation.file_response[0]);
            const response = await this.$store.dispatch("Auth/respondDemandeAttestation", formData);
            console.log(response); 
          } else if (this.isValidChoice === 'Demande non Validée') {
            const formData = new FormData();
            formData.append('attestation_id', this.id);
            formData.append('status', "Rejetée");
            formData.append('file_response', this.attestation.file_response[0]);
            const response = await this.$store.dispatch("Auth/respondDemandeAttestation", formData); 
            this.isValidChoice = "";
            this.attestation.file_response = null;
            console.log(response);
          }
           // Réinitialisation après l'envoi de la réponse
          this.isValidChoice = null;
          this.attestation.file_response = [];
        } catch (error) {
          console.error(error);
        } finally {
          this.isLoading = false;
        }
      },
    }
  };
  </script>
  <style>
  .w-62em {
    height: 62em !important;
    width: 100% !important;
  }
  
  .v-card__text {
    width: 100% !important;
  }
  
  .vue-friendly-iframe iframe {
    width: 100% !important;
    height: 62em !important;
  }
  </style>